import { ExternalSearchSystemResponse } from "./ExternalSearchSystemResponse";
import { ExternalSearchSystemSiteResponse } from "./ExternalSearchSystemSiteResponse";

class ExternalSearchSystem extends ExternalSearchSystemResponse {
    public Sites: ExternalSearchSystemSiteResponse[];

    constructor(init?: Partial<ExternalSearchSystemResponse>, sites?: ExternalSearchSystemSiteResponse[]) {
        super();
        Object.assign(this, init);
        this.Sites = sites || [];
    }
}

export { ExternalSearchSystem };
